export default __webpack_public_path__ + "static/media/nav-desk.22f92c83.webp";